export class FormOption {
  constructor(
    public value: string | number | boolean | null,
    public viewName: string,
    public hidden: boolean = false,
  ) {}
}
